export type ContactSalesFormProps = {
  headerText?: string;
  /** Marketo `requestedfeature` — which gated feature prompted the request. */
  requestedFeature?: string;
  /** Marketo `Website_Dr_Button__c` — which product the request is about. */
  productInterest?: string;
  onFormSubmit?(): void;
};

export const SUPPORT_TICKET_URL = 'https://support.launchdarkly.com/hc/en-us/requests/new';

/** Set instead of a real product interest so sandbox leads stay identifiable. */
export const SANDBOX_PRODUCT_INTEREST = 'dr-product-guardian';
